/* Gebert & Weschka — eigener Kaufweg für Produkte mit gerechnetem Versand.
   ===========================================================================
   Wofür (21.09.2026):

   Der Versand der Aluprofile hängt am Gewicht und an der Länge des längsten
   Teils. Shopify kann das im Basic-Tarif nicht rechnen, deshalb legt unser
   Dienst eine eigene Versandzeile in den Warenkorb. Diese Zeile muss im
   SELBEN Schritt entstehen wie der Artikel -- sonst steht der Warenkorb
   zwischendurch ohne Versand da, und mit einem 0-EUR-Versandprofil heißt das
   Versand geschenkt.

   Zwei Versuche, das an Shopifys Kaufknopf anzuflanschen, sind gescheitert:
     - nachträglich ergänzen (gw-korb.js): griff beim Laden der Warenkorbseite
       nicht zuverlässig.
     - den Klick abfangen (gw-pack-kauf.js): der Knopf löst kein `submit` aus,
       weil die App „Easy Product Addons" den Klick abfängt und das Formular
       selbst abschickt. Wer zuerst dran ist, hängt an der Ladereihenfolge --
       also am Zufall.

   Deshalb hier kein Abfangen mehr, sondern ein eigener Knopf: die Sektion
   gw-product-main rendert ihn mit `type="button"` und ohne `name="add"`, wenn
   in der Produktvorlage „Kauf über den Zuschnitt-Dienst abwickeln" gesetzt
   ist. Damit gibt es nichts, was ein anderes Skript abfangen könnte, und
   Shopifys Formular schickt nichts mehr ab. Der Ablauf ist immer derselbe:
   Dienst fragen -> EIN `/cart/add.js` mit Artikel und Versandzeile -> zum
   Warenkorb.

   Nebeneffekt, den der Standardknopf nie hatte: der Versandsatz steht schon
   VOR dem Kauf auf der Seite, gerechnet statt geschätzt.

   Solange der Dienst für Packs keine Zeile liefert (Schalter
   VERSAND_PACKS_MITRECHNEN in _build/profile_packs.py), verhält sich der
   Knopf wie ein normaler Kaufknopf: er legt nur den Artikel hinein, und
   Shopifys Pauschale gilt wie bisher. Der Knopf kann also vor dem Umschalten
   eingebaut und geprüft werden -- genau in dieser Reihenfolge, damit nie ein
   Loch entsteht.

   Gegenprobe der Titelerkennung: `py _server/zuschnitt/pruefe_titel.py`.
   =========================================================================== */
(function () {
  "use strict";

  function adresse() {
    var k = window.GW_CUT_CART || {};
    return String(k.dienst || "").replace(/\/+$/, "");
  }

  function istVersand(zeile) {
    var e = zeile.properties || {};
    if (e._gw_versand === "1" || e._gw_versand === 1) return true;
    return /^Versand\s+·/.test(zeile.product_title || "")
        || /^Versand\s+·/.test(zeile.title || "");
  }

  /* Der Titel, den der Dienst zu sehen bekommt. Aus drei Teilen, genau wie
     gw-korb.js ihn später aus der Warenkorbzeile zusammensetzt
     (product_title · variant_title · title) -- sonst rechnen die zwei beim
     Kauf und beim Nachprüfen Verschiedenes und reparieren sich im Kreis.
     Geprüft an den echten Shop-Titeln in pruefe_titel.py. */
  function titelVon(zeile) {
    return [zeile.product_title || "", zeile.variant_title || "",
            zeile.title || ""].join(" · ");
  }
  function titelNeu(produkt, variante) {
    return [produkt, variante, produkt + " - " + variante].join(" · ");
  }

  function post(pfad, koerper) {
    return fetch(pfad, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(koerper)
    }).then(function (r) {
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r.json();
    });
  }

  /* ── Frische Varianten brauchen einen Moment ──────────────────────────────
     Am 21.09.2026 am echten Shop gemessen: eine Variante, die der Dienst
     gerade angelegt hat, weist der Warenkorb mit HTTP 422 ab. Vier Versuche
     hintereinander scheiterten, erst der fuenfte nach 5,3 Sekunden ging
     durch. Betroffen ist hier die Versandzeile -- die Pack-Variante selbst
     liegt dauerhaft im Shop.

     Bewusst alles oder nichts: scheitert es endgueltig, kommt AUCH das Pack
     nicht in den Warenkorb. Ein Pack ohne Versandzeile waere bei einem
     0-EUR-Versandprofil genau der teure Fall. Lieber eine klare Meldung. */
  var WARTEN = [1200, 1800, 2400, 3000, 3600, 4200];

  function warte(ms) {
    return new Promise(function (f) { setTimeout(f, ms); });
  }

  function anlegen(stuecke, nr) {
    var i = nr || 0;
    return post("/cart/add.js", { items: stuecke }).catch(function (e) {
      /* Nur bei 422 weiterprobieren -- ein ausverkauftes Pack soll nicht
         zwanzig Sekunden lang hoffen lassen. post() gibt den Status im Text
         mit. Gemessen am 21.09.2026: eine frische Variante brauchte einmal
         5,3 und einmal rund 13 Sekunden, deshalb das weite Fenster. */
      if (i >= WARTEN.length || String(e.message).indexOf("422") < 0) throw e;
      return warte(WARTEN[i]).then(function () {
        return anlegen(stuecke, i + 1);
      });
    });
  }

  function holeKorb() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); });
  }

  function euro(betrag) {
    var n = Number(betrag);
    if (!isFinite(n)) return "";
    return n.toFixed(2).replace(".", ",") + " €";
  }

  function aufbauen(kasten) {
    /* Die Felder stehen in Shopifys Formular -- das bleibt im Markup, es
       schickt nur nichts mehr ab. So bleiben Variantenwahl, Preisanzeige und
       die Nettozeile aus gw.js unberührt. */
    var feld = kasten.querySelector('[name="id"]');
    var mengeFeld = kasten.querySelector('[name="quantity"]');
    var versandZeile = kasten.querySelector("[data-gw-versand]");
    var hinweis = kasten.querySelector("[data-gw-hinweis]");
    if (!feld) return;

    /* Beide Kaufknöpfe der Seite: der in der Kaufbox und der in der Leiste,
       die beim Scrollen erscheint. Der zweite steht außerhalb des Kastens. */
    var knoepfe = document.querySelectorAll("[data-gw-kaufen]");
    if (!knoepfe.length) return;

    var produktTitel = kasten.getAttribute("data-produkt-titel") || "";

    function menge() {
      var n = Number(mengeFeld && mengeFeld.value);
      return isFinite(n) && n > 0 ? Math.floor(n) : 1;
    }
    function variantenId() {
      var n = Number(feld.value);
      return isFinite(n) && n > 0 ? n : null;
    }
    function variantenTitel() {
      if (feld.tagName === "SELECT") {
        var o = feld.options[feld.selectedIndex];
        return (o && o.getAttribute("data-titel")) || "";
      }
      return feld.getAttribute("data-titel") || "";
    }
    function melde(text) {
      if (!hinweis) return;
      hinweis.textContent = text || "";
      hinweis.hidden = !text;
    }

    /* Die Titel des künftigen Warenkorbs: was schon drin ist (ohne
       Versandzeilen) plus das, was gerade gewählt ist. */
    function kuenftig() {
      return holeKorb().then(function (korb) {
        var titel = (korb.items || [])
          .filter(function (z) { return !istVersand(z); })
          .map(function (z) { return { titel: titelVon(z), menge: z.quantity || 1 }; });
        titel.push({ titel: titelNeu(produktTitel, variantenTitel()),
                     menge: menge() });
        return { korb: korb, titel: titel };
      });
    }

    /* Versandsatz anzeigen, bevor jemand kauft. Schlägt es fehl, bleibt die
       Zeile leer -- die Pauschale steht ohnehin in der Steuerzeile darüber. */
    var laufendeAnfrage = 0;
    function versandZeigen() {
      var dienst = adresse();
      if (!dienst || !versandZeile) return;
      var meine = ++laufendeAnfrage;
      versandZeile.textContent = "Versand wird berechnet …";
      kuenftig()
        .then(function (d) {
          return post(dienst + "/zuschnitt/versandzeile", { titel: d.titel });
        })
        .then(function (a) {
          if (meine !== laufendeAnfrage) return;      /* überholte Antwort */
          /* An `preis` haengen, nicht an `zeile`: im Zuschlag-Betrieb braucht
             der haeufige Fall gar keine eigene Zeile (Shopifys Pauschale
             stimmt dann schon), der Satz gehoert aber trotzdem auf die
             Seite. */
          if (!a.ok || !(Number(a.preis) > 0)) {
            versandZeile.textContent = "";
            return;
          }
          var text = "zzgl. Versand " + euro(a.preis);
          if (a.stufe) text += " · " + a.stufe;
          if (a.kg) text += " · " + String(a.kg).replace(".", ",") + " kg";
          versandZeile.textContent = text;
        })
        .catch(function () {
          if (meine === laufendeAnfrage) versandZeile.textContent = "";
        });
    }

    function kaufen(knopf) {
      var dienst = adresse();
      var id = variantenId();
      if (!id) return;

      /* Der Text steht in einem inneren <span> (gw.js zieht ihn beim
         Variantenwechsel mit). Also von dort lesen und dorthin zurueck --
         knopf.textContent brächte den Rand-Leerraum mit. */
      var label = knopf.querySelector("[data-gw-atc-label]") || knopf;
      var alterText = label.textContent;
      for (var i = 0; i < knoepfe.length; i++) knoepfe[i].disabled = true;
      label.textContent = "Wird hinzugefügt …";
      melde("");

      var artikel = { id: id, quantity: menge() };

      /* Ohne Dienstadresse gar nicht erst fragen: dann ist es ein ganz
         normaler Kauf mit Shopifys Pauschale. */
      var vorbereiten = dienst
        ? kuenftig().then(function (d) {
            return post(dienst + "/zuschnitt/versandzeile", { titel: d.titel })
              .then(function (a) {
                return { alt: (d.korb.items || []).filter(istVersand),
                         neu: (a.ok && a.zeile) ? a.zeile : null };
              });
          })
        : Promise.resolve({ alt: [], neu: null });

      vorbereiten
        .then(function (plan) {
          /* Liegt genau diese Versandzeile schon im Warenkorb, darf sie NICHT
             noch einmal hinein -- Shopify verschmilzt gleiche Zeilen zu einer
             mit doppelter Menge, und der Kunde zahlt den Versand zweimal. */
          plan.behalten = null;
          if (plan.neu) {
            for (var i = 0; i < plan.alt.length; i++) {
              if (plan.alt[i].id === plan.neu.id) { plan.behalten = plan.alt[i]; break; }
            }
          }
          var stuecke = (plan.neu && !plan.behalten) ? [artikel, plan.neu] : [artikel];
          return anlegen(stuecke).then(function () { return plan; });
        })
        .then(function (plan) {
          /* Eine ältere Versandzeile kann jetzt weg -- erst JETZT, damit der
             Warenkorb nie ohne Versand dasteht. Geht es schief, räumt
             gw-korb.js auf der Warenkorbseite nach. */
          var kette = Promise.resolve();
          plan.alt.forEach(function (z) {
            /* Die passende Zeile bleibt -- sie ist ja die richtige. Nur ihre
               Menge geradeziehen, falls sie sich schon vervielfacht hatte. */
            if (plan.behalten && z.key === plan.behalten.key) {
              if (z.quantity !== 1) {
                kette = kette.then(function () {
                  return post("/cart/change.js", { id: z.key, quantity: 1 })
                    .catch(function () {});
                });
              }
              return;
            }
            kette = kette.then(function () {
              return post("/cart/change.js", { id: z.key, quantity: 0 })
                .catch(function () {});
            });
          });
          return kette;
        })
        .then(function () { window.location.href = "/cart"; })
        .catch(function (e) {
          for (var i = 0; i < knoepfe.length; i++) knoepfe[i].disabled = false;
          label.textContent = alterText;
          melde("Das hat nicht geklappt (" + e.message + "). Bitte noch einmal "
              + "versuchen — oder kurz an business@gebertweschka.de schreiben, "
              + "dann legen wir die Bestellung von Hand an.");
        });
    }

    for (var i = 0; i < knoepfe.length; i++) {
      (function (knopf) {
        knopf.addEventListener("click", function (ereignis) {
          ereignis.preventDefault();
          kaufen(knopf);
        });
      }(knoepfe[i]));
    }

    feld.addEventListener("change", versandZeigen);
    if (mengeFeld) {
      mengeFeld.addEventListener("change", versandZeigen);
      mengeFeld.addEventListener("input", versandZeigen);
    }
    versandZeigen();
  }

  function starten() {
    var kaesten = document.querySelectorAll("[data-gw-eigenkauf]");
    for (var i = 0; i < kaesten.length; i++) {
      if (kaesten[i].dataset.gwGebunden === "1") continue;
      kaesten[i].dataset.gwGebunden = "1";
      aufbauen(kaesten[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", starten);
  } else {
    starten();
  }
  /* Im Theme-Editor wird ein Abschnitt neu gerendert, ohne dass die Seite
     lädt. Dann hängen die Ereignisse am alten Knopf. */
  document.addEventListener("shopify:section:load", starten);
}());
